import {API_URL} from "../config";
import axios from "../utils/axios";

class UserRepository
{
    getAll(filter) {
        return axios.get(API_URL + "/User/List?", { params: filter });
    }
}

export default UserRepository;